import Vue from "vue";
import VueRouter from "vue-router";

import RegistrationLayout from "@/layouts/RegistrationLayout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: RegistrationLayout,
    children: [
      {
        path: "contact-details",
        name: "ContactDetails",
        component: () => import("@/views/ContactDetails.vue"),
        meta: {
          title: "Contact Details",
        },
        beforeEnter: (to, from, next) => {
          const newRegistration = JSON.parse(sessionStorage.getItem("newRegistration"));
          if (newRegistration && newRegistration.registrationCode) {
            if (newRegistration.status === "SUCCESS") {
              next({ name: "Success" });
            } else if (newRegistration.verified) {
              next({ name: "InstituteDetails" });
            } else {
              next({ name: "Verification" });
            }
          } else {
            next();
          }
        },
      },
      {
        path: "verification",
        name: "Verification",
        component: () => import("@/views/Verification.vue"),
        meta: {
          title: "Verification",
        },
        beforeEnter: (to, from, next) => {
          const newRegistration = JSON.parse(sessionStorage.getItem("newRegistration"));
          if (newRegistration && newRegistration.registrationCode) {
            if (newRegistration.status === "SUCCESS") {
              next({ name: "Success" });
            } else if (newRegistration.verified) {
              next({ name: "InstituteDetails" });
            } else {
              next();
            }
          } else {
            next({ name: "ContactDetails" });
          }
        },
      },
      {
        path: "institute-details",
        name: "InstituteDetails",
        component: () => import("@/views/InstituteDetails.vue"),
        meta: {
          title: "Institute Details",
        },
        beforeEnter: (to, from, next) => {
          const newRegistration = JSON.parse(sessionStorage.getItem("newRegistration"));
          if (newRegistration && newRegistration.registrationCode) {
            if (newRegistration.status === "SUCCESS") {
              next({ name: "Success" });
            } else if (newRegistration.verified) {
              next();
            } else {
              next({ name: "Verification" });
            }
          } else {
            next({ name: "ContactDetails" });
          }
        },
      },
      {
        path: "success",
        name: "Success",
        component: () => import("@/views/Success.vue"),
        meta: {
          title: "Success",
        },
        beforeEnter: (to, from, next) => {
          const newRegistration = JSON.parse(sessionStorage.getItem("newRegistration"));
          if (newRegistration && newRegistration.registrationCode) {
            if (newRegistration.status === "SUCCESS") {
              next();
            } else if (newRegistration.verified) {
              next({ name: "InstituteDetails" });
            } else {
              next({ name: "Verification" });
            }
          } else {
            next({ name: "ContactDetails" });
          }
        },
      },
      // {
      //   path: "installing",
      //   name: "Installing",
      //   component: () => import("@/views/Installing.vue"),
      //   meta: {
      //     title: "Installing",
      //   },
      //   beforeEnter: (to, from, next) => {
      //     const newRegistration = JSON.parse(sessionStorage.getItem("newRegistration"));
      //     if (newRegistration && newRegistration.registrationCode) {
      //       if (newRegistration.status === "SUCCESS") {
      //         next();
      //       } else if (newRegistration.verified) {
      //         next({ name: "InstituteDetails" });
      //       } else {
      //         next({ name: "Verification" });
      //       }
      //     } else {
      //       next({ name: "ContactDetails" });
      //     }
      //   },
      // },
      {
        path: "*",
        redirect: () => {
          return {
            name: "ContactDetails",
          };
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
